import { fetchAPIWithID } from "../config";

export async function useCode(obj) {
  const data = await fetchAPIWithID("/ssm_api_store/usecode2", obj);
  return data;
}
